import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { AlertTypes } from '../shared/types';
import { SnackBarComponent } from '../components/snack-bar/snack-bar.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private _snackBar: MatSnackBar) { }

  info(title = 'Info', message = 'Information', duration = 4000, config = null): MatSnackBarRef<SnackBarComponent> {
    return this.showNotification(title, message, AlertTypes.Info, duration, config);
  }

  processing(title = 'Processing', message = 'Processing', duration = 6000, config = null): MatSnackBarRef<SnackBarComponent> {
    return this.showNotification(title, message, AlertTypes.Processing, duration, config);
  }

  success(title = 'Success', message = 'success', duration = 3000, config = null): MatSnackBarRef<SnackBarComponent> {
    return this.showNotification(title, message, AlertTypes.Success, duration, config);
  }

  error(title = 'Error', message = 'Failed!', duration = 3000, config = null): MatSnackBarRef<SnackBarComponent> {
    return this.showNotification(title, message, AlertTypes.Error, duration, config);
  }

  private showNotification(title: string, message: string, type: AlertTypes, duration: number, config = null): MatSnackBarRef<SnackBarComponent> {
    const snackBarConfig: any = {
      panelClass: ['custom-error-snackbar'],
      horizontalPosition: 'end',
      verticalPosition: 'top',
      data: {
        title: title,
        message: message,
        status: type,
        config: config,
      },
    };

    // Only set duration if it's greater than 0 (0 means persistent)
    if (duration > 0) {
      snackBarConfig.duration = duration;
    }

    return this._snackBar.openFromComponent(SnackBarComponent, snackBarConfig);
  }
}
